//COMMON
// import 'intersection-observer';
import './common';
import './vendors/setHeightHtml'

//SASS - COMMON
import '../sass/main.scss';

// import AOS from 'aos';
// import myLazyLoad from './vendors/lazyLoading';

// import customSelect from 'custom-select';
// import Scrollbar from 'smooth-scrollbar';

// AOS.init({
//   offset: ((window.innerWidth > 1024) ? 150 : 0),
//   duration: 1000, 
// });

// myLazyLoad.update();

// document.querySelectorAll('a[href^="#"]').forEach(a => {
//   a.addEventListener('click', function (e) {
//       e.preventDefault();
//       var href = this.getAttribute("href");
//       var elem = document.querySelector(href)||document.querySelector("a[name="+href.substring(1, href.length)+"]");
//       window.scroll({
//           top: elem.offsetTop - 120, 
//           left: 0, 
//           behavior: 'smooth' 
//       });
//   });
// });

// document.addEventListener("DOMContentLoaded", function() {
//   var lazyBackgrounds = [].slice.call(document.querySelectorAll(".lazy-background"));

//   if ("IntersectionObserver" in window) {
//     let lazyBackgroundObserver = new IntersectionObserver(function(entries, observer) {
//       entries.forEach(function(entry) {
//         if (entry.isIntersecting) {
//           entry.target.classList.add("visible");
//           lazyBackgroundObserver.unobserve(entry.target);
//         }
//       });
//     });

//     lazyBackgrounds.forEach(function(lazyBackground) {
//       lazyBackgroundObserver.observe(lazyBackground);
//     });
//   }
// });



const submenu = document.querySelectorAll('.navbar__item--submenu');

if(submenu) {
    submenu.forEach(el => {
        const link = el.querySelector('.navbar__link span');
        const submenu = el.querySelector('.submenu');

        link.addEventListener('click', e => {
            e.preventDefault();
            el.classList.toggle('active');
        })
    })
}

const mobileBtn = document.querySelector('.mobile-button');
const html = document.querySelector('html');

if(mobileBtn) {
    mobileBtn.addEventListener('click', e => {
        e.preventDefault();
        html.classList.toggle('active-mobile')
    })
}


window.onscroll = function() {stickyHeader()};

var header = document.getElementById("headerHolder");

function stickyHeader() {
  if (window.pageYOffset > 0) {
    html.classList.add("sticky-menu")
  } else {
    html.classList.remove("sticky-menu");
  }
} 